<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Adicionar produto</h5>
        <div role="button" class="btn-close" @click="close"></div>
      </div>

      <div class="modal-body">
        <error-component :errors="errors" v-if="showError" />

        <div id="qr-code-order-part"></div>
        <div class="w-100 mt-2 mx-auto">
          <button class="stop-cam-btn" type="button" v-if="stopCam" @click="stopScan">
            <img src="@/assets/icones/camera_noflash_alt.svg" alt="" />
          </button>
        </div>

        <form @submit.prevent="searchProduct">
          <row-component>
            <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
              <label>Código:</label>
              <label class="input-select-photo-label">
                <span @click="onCamera" class="input-photo-icone">
                  <img src="@/assets/icones/camera.svg" alt="" />
                </span>
                <input-component class="large-input" v-model="formData.code" />
              </label>
            </col-component>

            <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-0 mt-lg-4">
              <button-submit icon="search" name="Pesquisar" type="submit" />
            </col-component>
          </row-component>
        </form>

        <div v-if="product">
          <div class="d-flex flex-column flex-lg-row gap-3 mt-3">
            <img class="product-photo" v-if="product.photo" :src="product.photo" alt="" />
            <img class="product-photo" v-else src="@/assets/avatar.png" alt="" />

            <div class="w-100">
              <row-component>
                <col-component class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                  <label>Código:</label>
                  <input-component :model-value="product.ref" disabled />
                </col-component>

                <col-component class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                  <label>Peça:</label>
                  <input-component :model-value="product.name" disabled />
                </col-component>
              </row-component>

              <row-component>
                <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                  <label>Em estoque:</label>
                  <input-component :model-value="product.in_stock" disabled />
                </col-component>

                <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                  <label>Quantidade:</label>
                  <input-component v-model="formData.amount" type="number" @input="calculateTotal" />
                </col-component>

                <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                  <label>Preço UN:</label>
                  <input-component v-model="formData.price" v-money="MONEY" @input="calculateTotal" />
                </col-component>

                <col-component class-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                  <label>Preço total:</label>
                  <input-component v-model="formData.price_total" v-money="MONEY" />
                </col-component>
              </row-component>

              <div class="text-end mt-3">
                <button-submit :disabled="sendForm" icon="plus" name="Adicionar" @click="submit" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RowComponent from '@/components/row/RowComponent.vue';
import ColComponent from '@/components/row/ColComponent.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import ButtonSubmit from '@/components/buttons/ButtonSubmit.vue';
import ErrorComponent from '@/components/alerts/ErrorComponent.vue';
import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { Html5Qrcode } from 'html5-qrcode';
import { useToast } from 'vue-toastification';

const toast = useToast();

export default {
  name: 'OrderPartAddProduct',

  components: {
    RowComponent,
    ColComponent,
    InputComponent,
    ButtonSubmit,
    ErrorComponent
  },

  directives: {
    money: VMoney
  },

  props: {
    orderPartId: {
      required: true
    },
    barcode: {
      default: ''
    }
  },

  created() {
    if (this.barcode) {
      this.formData.code = this.barcode;
      this.searchProduct();
    }
  },

  mounted() {
    this.$nextTick(() => {
      const input = this.$el.querySelector('input.large-input, input.form-control');
      if (input) input.focus();
    });
  },

  beforeUnmount() {
    this.stopScan();
  },

  data() {
    return {
      MONEY,
      product: null,
      formData: {
        code: '',
        amount: 1,
        price: '0,00',
        price_total: '0,00'
      },
      errors: [],
      showError: false,
      sendForm: false,
      stopCam: false,
      html5QrCode: null,
      config: {
        fps: 10,
        qrbox: { width: 500, height: 150 }
      }
    };
  },

  methods: {
    close() {
      this.stopScan();
      this.$emit('close');
    },

    parseMoney(value) {
      if (!value) return 0;
      return Number(String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')) || 0;
    },

    formatMoney(value) {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value || 0);
    },

    calculateTotal() {
      const total = Number(this.formData.amount || 0) * this.parseMoney(this.formData.price);
      this.formData.price_total = this.formatMoney(total);
    },

    searchProduct() {
      const code = String(this.formData.code || '').trim();
      if (!code) return;

      this.formData.code = code;
      this.$store
        .dispatch('getOrderPartProduct', { code })
        .then(r => {
          this.product = {
            id: r.id,
            name: r.name,
            photo: r.photo,
            ref: r.ref || r.code,
            in_stock: r.in_stock ?? r.initial_inventory_store,
            part_id: r.id
          };
          this.formData.amount = 1;
          this.formData.price = r.sale_price || r.price || '0,00';
          this.calculateTotal();
          this.showError = false;
          this.errors = [];
        })
        .catch(() => {
          this.product = null;
          toast.warning(`Nenhum produto foi encontrado com referência: ${code}`, {
            timeout: 4000
          });
        });
    },

    onCamera() {
      if (this.stopCam) {
        this.stopScan();
        return;
      }

      this.html5QrCode = new Html5Qrcode('qr-code-order-part');
      this.stopCam = true;
      this.html5QrCode
        .start({ facingMode: 'environment' }, this.config, decodedText => {
          this.formData.code = decodedText;
          this.stopScan();
          this.searchProduct();
        })
        .catch(() => {
          this.stopCam = false;
          toast.error('Não foi possível iniciar a câmera', { timeout: 2000 });
        });
    },

    stopScan() {
      if (this.html5QrCode) {
        this.html5QrCode
          .stop()
          .then(() => this.html5QrCode.clear())
          .catch(() => {})
          .finally(() => {
            this.html5QrCode = null;
            this.stopCam = false;
          });
      } else {
        this.stopCam = false;
      }
    },

    submit() {
      if (!this.product || this.sendForm) return;

      this.sendForm = true;
      const payload = {
        order_part_id: this.orderPartId,
        part_id: this.product.part_id,
        amount: this.formData.amount,
        price: this.formData.price,
        price_total: this.formData.price_total
      };

      this.$store
        .dispatch('storeOrderPartItem', payload)
        .then(() => {
          this.sendForm = false;
          toast.success('Produto adicionado com sucesso', { timeout: 1500 });
          this.$emit('saved');
          this.close();
        })
        .catch(e => {
          this.sendForm = false;
          this.showError = true;
          this.errors = e.response?.data?.errors || [];
          toast.error('Erro ao adicionar produto', { timeout: 1500 });
        });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 20px;
  width: 1100px;
  max-width: 90%;
  position: relative;
  max-height: 80%;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.product-photo {
  width: 150px;
  height: 200px;
  object-fit: cover;
}

.input-select-photo-label {
  position: relative;
  height: 42px;
  width: 100%;
  cursor: pointer;
  outline: none;
}

.input-select-photo-label :deep(.form-control) {
  padding-right: 48px;
}

.input-photo-icone {
  height: 42px;
  width: 42px;
  text-align: center;
  padding: 0.65rem;
  background-color: #000000;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 2;
  cursor: pointer;
}

.input-photo-icone > img {
  display: block;
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(199deg) brightness(105%) contrast(100%);
}

.stop-cam-btn {
  height: 42px;
  width: 42px;
  text-align: center;
  padding: 0.4rem;
  outline: none;
  border: 0;
  background-color: #000;
}

.stop-cam-btn > img {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(199deg) brightness(105%) contrast(100%);
}
</style>
